import {createContext} from 'react';

export default createContext({
  billingStatus: null,
  userType: null,
  loading: false,
  error: null,
  fetchBillingStatus: () => {}
});